import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Swal from "sweetalert2";
import $ from "jquery";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import StatusFilter from "../../../common/statusFilter";
import { SWAL_SETTINGS, showFilterlist } from "../../../../../utils/Constants";
import {
    TrimText,
    formateDateWithMonth,
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import CustomPagination from "../../../common/custompagination";
import Sorting from "../../../common/sorting";
import * as bannerServices from "../../../services/banner.services";
import { useTranslation } from "react-i18next";
import CustomRangepicker from '../../../common/rangepicker';

const BannerTable = () => {
    const params = useParams();
    const { t } = useTranslation()
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [statsupdate, setStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState();
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Banners"), url: "/admin/cms/banner/list/1" },
    ];
    const [resetdate, setResetDate] = useState(false);

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", params.pgno || 1);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);
                bannerServices
                    .List(formData)
                    .then((data) => {
                        const responseData = data.data;
                        if (responseData) {
                            if (Array.isArray(responseData)) {
                                setList(responseData);
                                setDataLength(responseData.length);
                            } else if (responseData.list && Array.isArray(responseData.list)) {
                                setList(responseData.list);
                                setDataLength(responseData.total_records || responseData.list.length);
                            } else if (data.success && Array.isArray(data.data)) {
                                // In case the interceptor returns the body directly
                                setList(data.data);
                                setDataLength(data.data.length);
                            } else {
                                setList([]);
                                setDataLength(0);
                            }
                        }
                        setLoader(false);
                    })
                    .catch((error) => {
                        setTimeout(() => {
                            setLoader(false);
                        }, 500)
                        console.log("error ====> ", error);
                    });
            }
        }, 300);

        return () => clearTimeout(getData);
    }, [location, statsupdate, sorting, search, globalsearch]);

    const viewfunction = (row) => {
        navigate(`/admin/cms/banner/view/${row.id || row.id}`);
    };
    const Editfunction = (row) => {
        navigate(`/admin/cms/banner/${params.pgno || 1}/edit/${row.id || row.id}`);
    };

    const ChangeStatus = (data, Num) => {
        let ids = Array.isArray(data) ? data : [data];
        const payload = {
            o_id: ids,
            status: Num
        };
        Swal.fire({
            customClass: "swal-wide",
            title: t(`Are you sure you want to ${Num === 0 ? "inactive" : "active"} this Banner ?`),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes"),
            cancelButtonText: t("btn_cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                bannerServices
                    .Status(payload)
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>");
                    });
            }
        });
    };

    function Deletefunction(data) {
        Swal.fire({
            customClass: "swal-wide",
            title: t("msg_are_you_sure"),
            text: t("you_not_be_able_to_revert_this"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes_delete"),
            cancelButtonText: t("btn_cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                let ids = Array.isArray(data) ? data : [data];
                bannerServices
                    .Delete(ids)
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("deleteError");
                    });
            }
        });
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        if ($("#defaultstatus").length) $("#defaultstatus")[0].selectedIndex = 0;
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card overflow-hidden">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">{t("Banners List")}</h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("input_placeholder_search")}
                                            onChange={(e) => {
                                                setGlobalSearch(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                {/* <div className="me-3">
                                    <CustomRangepicker
                                        GetDateRange={(e) => {
                                            prepareSearch("createdAt", e);
                                        }}
                                        resetdate={resetdate}
                                    />
                                </div> */}
                                <div className="me-3">
                                    <StatusFilter
                                        className="cp"
                                        data={showFilterlist}
                                        prepareSearch={prepareSearch}
                                    />
                                </div>
                                <button
                                    type="reset"
                                    value="Reset"
                                    onClick={resetFilter}
                                    className="btn btn-warning float-right mr-2"
                                >
                                    {t("btn_reset_filter")}
                                </button>
                                <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => navigate(`/admin/cms/banner/add`)}
                                >
                                    {t("Add Banners")}
                                </button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                id="example-input"
                                className="table table-bordered border-t0 key-buttons text-nowrap w-100"
                            >
                                <thead>
                                    <tr>
                                        <th className='sr_head'>{t("S.No")}</th>
                                        <th>{t("Image")}</th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>{t("Title")}</span>
                                                <Sorting
                                                    sort={sorting}
                                                    handleSort={handleSort}
                                                    column="title"
                                                />
                                            </div>
                                        </th>
                                        <th>{t("Description")}</th>
                                        <th>{t("Redirect Target")}</th>
                                        <th className="created_head">
                                            <div className="sorting_column">
                                                <span>{t("Created Date")}</span>
                                                <Sorting
                                                    sort={sorting}
                                                    defaultSorting={defaultSorting}
                                                    handleSort={handleSort}
                                                    column="createdAt"
                                                />
                                            </div>
                                        </th>
                                        <th className="status_head">{t("Status")}</th>
                                        <th className="action_head">{t("Action")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader && datalength > 0 ? (
                                        <tr>
                                            <td colSpan={14}>
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {list.length ? (
                                                list.map((row, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>
                                                                {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                                            </td>
                                                            <td>
                                                                {row?.image ? (
                                                                    <img src={row.image} alt="banner" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                                                                ) : "No Image"}
                                                            </td>
                                                            <td>
                                                                {row?.title ? TrimText(row.title, 40) : "N/A"}
                                                            </td>
                                                            <td>
                                                                {row?.description ? TrimText(row.description, 40) : "N/A"}
                                                            </td>
                                                            <td>
                                                                {row?.redirect_type && row?.redirect_item_name ? (
                                                                    <div>
                                                                        <span className="badge bg-primary text-white text-capitalize me-1">
                                                                            {row.redirect_type}
                                                                        </span>
                                                                        <span className="text-dark fw-bold" title={row.redirect_item_name}>
                                                                            {TrimText(row.redirect_item_name, 25)}
                                                                        </span>
                                                                    </div>
                                                                ) : row?.redirect_type ? (
                                                                    <div>
                                                                        <span className="badge bg-secondary text-white text-capitalize me-1">
                                                                            {row.redirect_type}
                                                                        </span>
                                                                        {row?.redirect_id && <span className="text-muted">ID: {row.redirect_id}</span>}
                                                                    </div>
                                                                ) : row?.url ? (
                                                                    <a href={row.url} target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-underline" title={row.url}>
                                                                        {TrimText(row.url, 25)}
                                                                    </a>
                                                                ) : "N/A"}
                                                            </td>
                                                            <td>
                                                                {row?.createdAt
                                                                    ? formateDateWithMonth(row.createdAt)
                                                                    : "N/A"}
                                                            </td>
                                                            <td>
                                                                {row.status === 1 ? (
                                                                    <button
                                                                        className="btn ripple btn-main-primary signbtn"
                                                                        onClick={() => {
                                                                            ChangeStatus(row?.id || row?.id, 0);
                                                                        }}
                                                                    >
                                                                        {t("btn_active")}
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="btn ripple btn-secondary"
                                                                        onClick={() => {
                                                                            ChangeStatus(row?.id || row?.id, 1);
                                                                        }}
                                                                    >
                                                                        {t("btn_inactive")}
                                                                    </button>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <div className="d-flex">
                                                                    <button
                                                                        className="btn ripple btn-main-primary signbtn "
                                                                        onClick={() => {
                                                                            viewfunction(row);
                                                                        }}
                                                                    >
                                                                        {t("btn_view")}
                                                                    </button>

                                                                    <button
                                                                        className="btn ripple btn-success mlAction"
                                                                        onClick={() => {
                                                                            Editfunction(row);
                                                                        }}
                                                                    >
                                                                        {t("btn_edit")}
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        className="btn ripple btn-secondary mlAction"
                                                                        onClick={() => {
                                                                            Deletefunction(row?.id || row?.id);
                                                                        }}
                                                                    >
                                                                        {t("btn_delete")}
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={14} className="text-center">
                                                        {t("msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div
                            className=""
                            id="example1_info"
                            role="status"
                            aria-live="polite"
                        >
                            <b>{t("msg_total_records")} : {datalength ? datalength : "0"}</b>
                        </div>
                        {datalength && datalength > 0 ? (
                            <CustomPagination
                                datalength={datalength}
                                itemperpage={itemperpage}
                                setPage={setPage}
                                currentPage={page}
                                pageRoute={[
                                    { name: "BannerTable", path: "/admin/cms/banner/list" },
                                ]}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default BannerTable;
